import { Injectable } from '@angular/core';

declare let ACA_URL: string;
declare let ACA_URL_CN: string;

@Injectable({
  providedIn: 'root',
})
export class AppLocationService {
  public isQimaCn(): boolean {
    return location.origin.includes('qima.cn');
  }

  public backToHome(): void {
    location.replace(`${this.getAcaUrl()}/home`);
  }

  public getAcaUrl(): string {
    return this.isQimaCn() ? ACA_URL_CN : ACA_URL;
  }
}
